const flutterCabinet = {
  en: {
    flutterCabinet: {
      Подтвердить: 'Confirm',
      Переоформить: 'Re-register',
      office: 'Office',
      policies: 'My policies',
      policy: 'Policy',
      profile: 'Profile',
      noData: 'No data to display',
      period: 'Period of validity',
      valid: 'Valid until:',
      policyInf: 'Policy information',
      policyHolder: 'Policy holder',
      policyActive: 'Policy has been active since',
      expiry: 'Expiry date',
      insured: 'Insured',
      vehicles: 'Vehicles',
      cost: 'Cost',
      download: 'Download PDF',
      logout: 'Log out',
      coverage: 'Coverage',
      phoneNumber: 'Phone number',
      iin: 'IIN',
      login: 'Log in to your account',
      enterPhone:
        'Enter your IIN and password to log in to your personal account',
      'phoneNumber.lower': 'Phone number',
      password: 'Password',
      'login.short': 'Log in',
      forgotPassword: 'Forgot your password?',
      resetPassword: 'Reset password',
      enterIIN: 'Enter your IIN',
      notRegistered: 'Not registered yet?',
      register: 'Register',
      lastname: 'Last name',
      name: 'First name',
      middleName: 'Middle name',
      birthDate: 'Birth date',
      applications: 'Insurance claims',
      newApp: 'New application',
      notifications: 'Notifications',
      emptyNotifications: 'No notifications',
      otherPolicies: 'Other policies',
      archive: 'Archive',
      asApplicant: 'As an applicant:',
      asParticipant: 'As a participant:',
      asVictim: 'As a victim:',
      asPerpetrator: 'As a perpetrator:',
      status: 'Status',
      downloadApp: 'Download the application',
      insuredEventStatuses: 'History of insured event statuses',
      documents: 'Documents',
      generalDocs: 'General documents',
      beneficiaryDocs: "Beneficiary's documents",
      evalReport: 'Evaluation report',
      revalReport: 'Revaluation report',
      rejection: 'Notification',
      ombudsman: 'Contact the insurance Ombudsman',
      whatsapp: 'Write to WhatsApp',
      edit: 'Edit',
      back: 'Back',
      registerTitle: 'User Registration',
      registerDescription:
        'Please enter the IIN and the phone number to which the SMS code will be sent',
      registerSuccess: 'You have successfully registered!',
      registerPasswordSend: 'Your password has been sent to the phone number',
      registerOTPCode: 'Enter the SMS code',
      registerOTPCodeSend: 'Enter the SMS code sent to the number:',
      registerPhone: 'Enter your phone number',
      logIn: 'Entrance',
      passwordRecovery: 'Password Recovery',
      enterIINRecovery: 'Please specify the IIN that you used to log in',
      'Обязательное автострахование': 'Обязательное автострахование',
      'Добровольное страхование автомобильного транспорта':
        'Добровольное страхование автомобильного транспорта',
      'Добровольное страхование гражданско-правовой ответственности перевозчика':
        'Добровольное страхование гражданско-правовой ответственности перевозчика',
      'Добровольное страхование гражданско-правовой ответственности':
        'Добровольное страхование гражданско-правовой ответственности',
      'Добровольное страхование имущества от ущерба':
        'Добровольное страхование имущества от ущерба',
      'Добровольное страхование грузов': 'Добровольное страхование грузов',
      'Добровольное страхование от несчастных случаев':
        'Добровольное страхование от несчастных случаев',
      'Добровольное страхование на случай  болезни':
        'Добровольное страхование на случай болезни',
      'Страхование профессиональной ответственности':
        'Страхование профессиональной ответственности',
      Подробнее: 'More details',
      Расторгнуть: 'Terminate',
      'Пожалуйста, выберите причину расторжения.':
        'Please select a termination reason.',
      'Пожалуйста, укажите IBAN.': 'Please enter your IBAN.',
      'Пожалуйста, укажите корректный IBAN (начинается с KZ и состоит из 20 символов).':
        'Please enter a valid IBAN (starts with KZ and is 20 characters long).',
      'Заявление на расторжение договора': 'Contract termination application',
      Номер: 'Number',
      'Дата заключения': 'Contract date',
      'Причина расторжения': 'Termination reason',
      'Необходимо указать ваш личный IBAN счет':
        'You must specify your personal IBAN account',
      'Сумма возврата': 'Refund amount',
      'Заявление успешно создано. Подпишите заявление':
        'The application has been created. Please sign it',
      'Перейти к подписанию': 'Proceed to signing',
      'Создать заявление': 'Create application',
      'Тип документа': 'Document type',
      'Номер документа': 'Document number',
      'Дата документа': 'Document date',
      Автор: 'Author',
      Отправитель: 'Sender',
      'UUID документа': 'Document UUID',
      Подписанты: 'Signers',
      Подписать: 'Sign',
      'Запросить SMS-код на подписания': 'Request SMS code to sign',
      'Номер:': 'Number:',
      Запросить: 'Request',
      'Введите SMS-код, отправленный на номер:':
        'Enter the SMS code sent to the number:',
      'Ошибка подтверждения sms-кода': 'SMS code confirmation error',
      Повторить: 'Retry',
      Успешно: 'Success',
      'Договор расторгнут, возврат поступит в течении 3-10 рабочих дней!':
        'The contract has been terminated. Refund will arrive within 3–10 business days!',
      Закрыть: 'Close',
      Документ: 'Document',
      Подписание: 'Signing',
      'Загрузка...': 'Loading...',
      Ошибка: 'Error:',
      'Нет данных для отображения': 'No data to display',
      'Посмотреть документ': 'View document',
      'Скачать документ': 'Download document',
      'Я подтверждаю, что данный счет является моим, а не третьего лица':
        'I confirm that this account belongs to me and not to a third party',
      'Пожалуйста, подтвердите, что указанный счет принадлежит вам, а не третьему лицу':
        'Please confirm that the specified account belongs to you and not to a third party',
    },
  },
  kz: {
    flutterCabinet: {
      Подтвердить: 'Растау',
      Переоформить: 'Қайта рәсімдеу',
      office: 'Кабинет',
      policies: 'Менің полистерім',
      policy: 'Полис',
      profile: 'Профиль',
      noData: 'Көрсету үшін деректер жоқ',
      period: 'Жарамдылық мерзімі',
      valid: 'Дейін жарамды:',
      policyInf: 'Полис туралы ақпарат',
      policyHolder: 'Сақтанушы',
      policyActive: 'Полис ... бастап белсенді',
      expiry: 'Аяқталу күні',
      insured: 'Сақтандырылушылар',
      vehicles: 'Көлік құралдары',
      cost: 'Құны',
      download: 'PDF жүктеп алу',
      logout: 'Шығу',
      coverage: 'Қамту',
      phoneNumber: 'Телефон нөміріңіз',
      iin: 'ЖСН',
      login: 'Жеке кабинетке кіру',
      enterPhone: 'Жеке кабинетке кіру үшін ЖСН мен парольді енгізіңіз',
      'phoneNumber.lower': 'Телефон нөмірі',
      password: 'Құпия сөз',
      'login.short': 'Кіру',
      forgotPassword: 'Құпия сөз ұмытып қалдыңыз ба?',
      resetPassword: 'Құпия сөзді қалпына келтіру',
      enterIIN: 'ЖСН енгізіңіз',
      notRegistered: 'Тіркелмегенсіз ба?',
      register: 'Тіркелу',
      lastname: 'Тегі',
      name: 'Аты',
      middleName: 'Әкесінің аты',
      birthDate: 'Туған күні',
      applications: 'Сақтандыру жағдайына өтініштер',
      newApp: 'Жаңа өтініш',
      notifications: 'Хабарламалар',
      emptyNotifications: 'Хабарламалар жоқ',
      otherPolicies: 'Басқа полистер',
      archive: 'Архив',
      asApplicant: 'Өтініш беруші ретінде:',
      asParticipant: 'Қатысушы ретінде:',
      asVictim: 'Жәбірленуші ретінде:',
      asPerpetrator: 'Кінәлі ретінде:',
      status: 'Статус',
      downloadApp: 'Өтінішті жүктеу',
      insuredEventStatuses: 'Сақтандыру іс жағдайының тарихы',
      documents: 'Құжаттар',
      generalDocs: 'Жалпы құжаттар',
      beneficiaryDocs: 'Пайда алушының құжаттары',
      evalReport: 'Бағалау есебі',
      revalReport: 'Қайта бағалау есебі',
      rejection: 'Хабарлама',
      ombudsman: 'Сақтандыру Омбудсманына хабарласыңыз',
      whatsapp: 'WhatsApp-қа жазу',
      edit: 'Өзгерту',
      back: 'Артқа',
      registerTitle: 'Пайдаланушыны тіркеу',
      registerDescription:
        'ЖСН және СМС-код жіберілетін телефон нөмірін енгізіңіз',
      registerSuccess: 'Сіз сәтті тіркелдіңіз!',
      registerPasswordSend: 'Сіздің пароліңіз телефон нөміріңізге жіберілді',
      registerOTPCode: 'SMS кодын енгізіңіз',
      registerOTPCodeSend: 'Нөмірге жіберілген SMS кодын енгізіңіз:',
      registerPhone: 'Телефон нөмірін енгізіңіз',
      logIn: 'Кіру',
      passwordRecovery: 'Құпия сөзді қалпына келтіру',
      enterIINRecovery: 'Кіру үшін пайдаланған ЖСН-ді енгізіңіз',
      'Обязательное автострахование': 'Міндетті автосақтандыру',
      'Добровольное страхование автомобильного транспорта':
        'Автомобиль көлігін ерікті сақтандыру',
      'Добровольное страхование гражданско-правовой ответственности перевозчика':
        'Тасымалдаушының жолаушылар алдындағы жауапкершілігін ерікті сақтандыру',
      'Добровольное страхование гражданско-правовой ответственности':
        'Азаматтық-құқықтық жауапкершілігін ерікті сақтандыру',
      'Добровольное страхование имущества от ущерба':
        'Мүлікті залалдан ерікті сақтандыру',
      'Добровольное страхование грузов': 'Жүктерін ерікті сақтандыру',
      'Добровольное страхование от несчастных случаев':
        'Жазатайым оқиғалардан сақтандыру',
      'Добровольное страхование на случай  болезни':
        'Ауырған жағдайда ерікті сақтандыру',
      'Страхование профессиональной ответственности':
        'Кәсіби жауапкершілікті сақтандыру',

      Подробнее: 'Толығырақ',
      Расторгнуть: 'Бұзу',
      'Пожалуйста, выберите причину расторжения.':
        'Шартты бұзу себебін таңдаңыз.',
      'Пожалуйста, укажите IBAN.': 'IBAN енгізіңіз.',
      'Пожалуйста, укажите корректный IBAN (начинается с KZ и состоит из 20 символов).':
        'KZ әріптерінен басталатын және 20 таңбадан тұратын дұрыс IBAN енгізіңіз.',
      'Заявление на расторжение договора': 'Шартты бұзу туралы өтініш',
      Номер: 'Нөмірі',
      'Дата заключения': 'Жасалған күні',
      'Причина расторжения': 'Бұзу себебі',
      'Необходимо указать ваш личный IBAN счет':
        'Жеке IBAN шотыңызды көрсету қажет',
      'Сумма возврата': 'Қайтару сомасы',
      'Заявление успешно создано. Подпишите заявление':
        'Өтініш сәтті құрылды. Өтінішті қол қойыңыз',
      'Перейти к подписанию': 'Қол қоюға өту',
      'Создать заявление': 'Өтініш жасау',
      'Тип документа': 'Құжат түрі',
      'Номер документа': 'Құжат нөмірі',
      'Дата документа': 'Құжат күні',
      Автор: 'Автор',
      Отправитель: 'Жіберуші',
      'UUID документа': 'Құжат UUID',
      Подписанты: 'Қол қоюшылар',
      Подписать: 'Қол қою',
      'Запросить SMS-код на подписания': 'Қол қою үшін SMS-код сұрау',
      'Номер:': 'Нөмір:',
      Запросить: 'Сұрау',
      'Введите SMS-код, отправленный на номер:':
        'Нөмірге жіберілген SMS-кодты енгізіңіз:',
      'Ошибка подтверждения sms-кода': 'SMS-кодты растау қатесі',
      Повторить: 'Қайталау',
      Успешно: 'Сәтті',
      'Договор расторгнут, возврат поступит в течении 3-10 рабочих дней!':
        'Шарт бұзылды, қайтару 3-10 жұмыс күні ішінде түседі!',
      Закрыть: 'Жабу',
      Документ: 'Құжат',
      Подписание: 'Қол қою',
      'Загрузка...': 'Жүктелуде...',
      Ошибка: 'Қате:',
      'Нет данных для отображения': 'Көрсетілетін деректер жоқ',
      'Посмотреть документ': 'Құжатты көру',
      'Скачать документ': 'Құжатты жүктеу',
      'Я подтверждаю, что данный счет является моим, а не третьего лица':
        'Бұл шот менікі екенін, үшінші тұлғаға тиесілі емес екенін растаймын',
      'Пожалуйста, подтвердите, что указанный счет принадлежит вам, а не третьему лицу':
        'Көрсетілген шот сізге тиесілі екенін растаңыз, үшінші тұлғаның шоты емес',
    },
  },
  ru: {
    flutterCabinet: {
      Подтвердить: 'Подтвердить',
      Переоформить: 'Переоформить',
      office: 'Кабинет',
      policies: 'Мои полисы',
      policy: 'Полис',
      profile: 'Профиль',
      noData: 'Нет данных для отображения',
      period: 'Срок действия',
      valid: 'Действителен до:',
      policyInf: 'Информация о полисе',
      policyHolder: 'Страхователь',
      policyActive: 'Полис активен с',
      expiry: 'Дата окончания',
      insured: 'Застрахованные',
      vehicles: 'Транспортные средства',
      cost: 'Стоимость',
      download: 'Скачать PDF',
      logout: 'Выйти',
      coverage: 'Покрытие',
      phoneNumber: 'Номер телефона',
      iin: 'ИИН',
      login: 'Вход в личный кабинет',
      enterPhone: 'Введите свой ИИН и пароль чтобы зайти в личный кабинет',
      'phoneNumber.lower': 'Номер телефона',
      password: 'Пароль',
      'login.short': 'Войти',
      forgotPassword: 'Забыли пароль?',
      resetPassword: 'Восстановление пароля',
      enterIIN: 'Введите ИИН',
      notRegistered: 'Еще не зарегистрированы?',
      register: 'Создать аккаунт',
      lastname: 'Фамилия',
      name: 'Имя',
      middleName: 'Отчество',
      birthDate: 'Дата рождения',
      applications: 'Заявки на страховой случай',
      newApp: 'Новая заявка',
      notifications: 'Уведомления',
      emptyNotifications: 'Нет уведомлений',
      otherPolicies: 'Прочие полисы',
      archive: 'Архив',
      asApplicant: 'Как заявитель:',
      asParticipant: 'Как участник:',
      asVictim: 'Как потерпевший:',
      asPerpetrator: 'Как виновник:',
      status: 'Статус',
      downloadApp: 'Скачать заявление',
      insuredEventStatuses: 'История статусов заявки',
      documents: 'Документы',
      generalDocs: 'Общие документы',
      beneficiaryDocs: 'Документы выгодоприобретателя',
      evalReport: 'Отчет об оценке',
      revalReport: 'Отчет о переоценке',
      rejection: 'Уведомление',
      ombudsman: 'Обратиться к страховому Омбудсману',
      whatsapp: 'Написать в WhatsApp',
      edit: 'Редактировать',
      back: 'Назад',
      registerTitle: 'Регистрация пользователя',
      registerDescription:
        'Пожалуйста, введите ИИН и номер телефона, на который будет отправлен СМС-код',
      registerSuccess: 'Вы успешно зарегистрировались!',
      registerPasswordSend: 'Ваш пароль отправлен на номер телефона',
      registerOTPCode: 'Введите SMS-код',
      registerOTPCodeSend: 'Введите SMS-код, отправленный на номер:',
      registerPhone: 'Введите номер телефона',
      logIn: 'Вход',
      passwordRecovery: 'Восстановление пароля',
      enterIINRecovery:
        'Пожалуйста, укажите ИИН, который вы использовали для входа',
      'Обязательное автострахование': 'Обязательное автострахование',
      'Добровольное страхование автомобильного транспорта':
        'Добровольное страхование автомобильного транспорта',
      'Добровольное страхование гражданско-правовой ответственности перевозчика':
        'Добровольное страхование гражданско-правовой ответственности перевозчика',
      'Добровольное страхование гражданско-правовой ответственности':
        'Добровольное страхование гражданско-правовой ответственности',
      'Добровольное страхование имущества от ущерба':
        'Добровольное страхование имущества от ущерба',
      'Добровольное страхование грузов': 'Добровольное страхование грузов',
      'Добровольное страхование от несчастных случаев':
        'Добровольное страхование от несчастных случаев',
      'Добровольное страхование на случай  болезни':
        'Добровольное страхование на случай болезни',
      'Страхование профессиональной ответственности':
        'Страхование профессиональной ответственности',
      Подробнее: 'Подробнее',
      Расторгнуть: 'Расторгнуть',
      'Пожалуйста, выберите причину расторжения.':
        'Пожалуйста, выберите причину расторжения.',
      'Пожалуйста, укажите IBAN.': 'Пожалуйста, укажите IBAN.',
      'Пожалуйста, укажите корректный IBAN (начинается с KZ и состоит из 20 символов).':
        'Пожалуйста, укажите корректный IBAN (начинается с KZ и состоит из 20 символов).',
      'Заявление на расторжение договора': 'Заявление на расторжение договора',
      Номер: 'Номер',
      'Дата заключения': 'Дата заключения',
      'Причина расторжения': 'Причина расторжения',
      'Необходимо указать ваш личный IBAN счет':
        'Необходимо указать ваш личный IBAN счет',
      'Сумма возврата': 'Сумма возврата',
      'Заявление успешно создано. Подпишите заявление':
        'Заявление успешно создано. Подпишите заявление',
      'Перейти к подписанию': 'Перейти к подписанию',
      'Создать заявление': 'Создать заявление',
      'Тип документа': 'Тип документа',
      'Номер документа': 'Номер документа',
      'Дата документа': 'Дата документа',
      Автор: 'Автор',
      Отправитель: 'Отправитель',
      'UUID документа': 'UUID документа',
      Подписанты: 'Подписанты',
      Подписать: 'Подписать',
      'Запросить SMS-код на подписания': 'Запросить SMS-код на подписания',
      'Номер:': 'Номер:',
      Запросить: 'Запросить',
      'Введите SMS-код, отправленный на номер:':
        'Введите SMS-код, отправленный на номер:',
      'Ошибка подтверждения sms-кода': 'Ошибка подтверждения sms-кода',
      Повторить: 'Повторить',
      Успешно: 'Успешно',
      'Договор расторгнут, возврат поступит в течении 3-10 рабочих дней!':
        'Договор расторгнут, возврат поступит в течении 3-10 рабочих дней!',
      Закрыть: 'Закрыть',
      Документ: 'Документ',
      Подписание: 'Подписание',
      'Загрузка...': 'Загрузка...',
      Ошибка: 'Ошибка:',
      'Нет данных для отображения': 'Нет данных для отображения',
      'Посмотреть документ': 'Посмотреть документ',
      'Скачать документ': 'Скачать документ',
      'Я подтверждаю, что данный счет является моим, а не третьего лица':
        'Я подтверждаю, что данный счет является моим, а не третьего лица',
      'Пожалуйста, подтвердите, что указанный счет принадлежит вам, а не третьему лицу':
        'Пожалуйста, подтвердите, что указанный счет принадлежит вам, а не третьему лицу',
    },
  },
};

export default flutterCabinet;
